import { VisitState } from '@/types/visit';
import AirportShuttle from '@mui/icons-material/AirportShuttle';
import CheckCircle from '@mui/icons-material/CheckCircle';
import DateRange from '@mui/icons-material/DateRange';
import Event from '@mui/icons-material/Event';
import EventAvailable from '@mui/icons-material/EventAvailable';
import FastForward from '@mui/icons-material/FastForward';
import LocationOn from '@mui/icons-material/LocationOn';
import RateReview from '@mui/icons-material/RateReview';
import { SvgIconProps } from '@mui/material';

export const VisitStateIcon = ({ state, ...rest }: { state: VisitState } & SvgIconProps) => {
    switch (state) {
        case VisitState.UNSCHEDULED:
            return <DateRange {...rest} />;
        case VisitState.SCHEDULED:
            return <Event {...rest} />;
        case VisitState.EN_ROUTE:
            return <AirportShuttle {...rest} />;
        case VisitState.AT_LOCATION:
            return <LocationOn {...rest} />;
        case VisitState.CONFIRMED:
            return <EventAvailable {...rest} />;
        case VisitState.IN_REVIEW:
            return <RateReview {...rest} />;
        case VisitState.ENDED:
            return <CheckCircle {...rest} />;
        default:
            return <FastForward {...rest} />;
    }
};
